<template>
  <div class="modal-utilize-container">
    <sweet-modal ref="modal" overlay-theme="dark" @close="onClose"
                 blocking :pulseOnBlock="false" hideCloseButton>
      <div class="flex-between" style="margin-bottom:36px">
        <div class="modal-title">수기 매출 {{ updateItem ? '수정' : '등록' }}</div>
        <i class="material-icons unselect" @click="clickCancel">close</i>
      </div>
      <div class="content" v-if="item">
        <div class="grid-item">
          <div class="grid-title">매출등록 담당자</div>
          <div>{{ item.manager.name }}</div>
        </div>
        <div class="grid-item">
          <div class="grid-title">서비스</div>
          <lp-adm-drop-input :data="option.service"
                             @onSelect="onSelectService"
                             :selectVal="selVal.service"
                             placeholder="검색 후 선택"
                             width="250px"
                             listAlign="left"></lp-adm-drop-input>
        </div>
        <div class="grid-item">
          <div class="grid-title">제공 서비스 구분</div>
          <select class="input-border" v-model="item.category_id" style="width:150px">
            <option v-for="(item,idx) in option.category" :key="`option-cat-${idx}`"
                    :value="item.value">{{ item.label }}</option>
          </select>
        </div>
        <div class="grid-item">
          <div class="grid-title">상품</div>
          <div>
            <template v-if="!add.visible">
              <lp-adm-drop-input :data="option.product"
                                 @onSelect="onSelectProduct"
                                 :selectVal="selVal.product"
                                 placeholder="검색 후 선택"
                                 width="250px"
                                 listAlign="left"></lp-adm-drop-input>
              <div class="button-primary unselect" @click="add.visible=true">+ 상품 추가</div>
            </template>
            <div class="box-add" v-else>
              <div class="box-title">상품명</div>
              <input type="text" class="input-border"
                     v-model="add.product.name" @keyup="e => add.product.name = e.target.value">
              <div class="box-title">설명</div>
              <textarea rows="4" class="input-border" v-model="add.product.simple_desc"
                        @keyup="e => add.product.simple_desc = e.target.value"></textarea>
              <div class="box-title">금액</div>
              <div class="flex-between">
                <div class="flex-align" style="width:150px;gap:0 8px">
                  <input type="number" class="input-border"
                         v-model="add.price.price"
                         @keyup="e => add.price.price = Number(e.target.value)">
                  <div>원</div>
                </div>
                <div class="size-13 unselect" @click="add.visible=false">취소</div>
              </div>
            </div>
          </div>
        </div>
        <div class="grid-item" v-if="!add.visible">
          <div class="grid-title">상품 금액</div>
          <div class="flex-align" style="width:150px;gap:0 8px">
            <input type="number" class="input-border"
                   v-model="item.product_price"
                   @keyup="e => item.product_price = Number(e.target.value)">
            <div>원</div>
          </div>
        </div>
        <div class="grid-item">
          <div class="grid-title">결제수단 구분</div>
          <select class="input-border" v-model="item.pay_method" style="width:160px">
            <option v-for="(item,idx) in option.payMethod" :key="`option-pay-${idx}`"
                    :value="item.value">{{ item.label }}</option>
          </select>
        </div>

        <div class="grid-item">
          <div class="grid-title">청구상태</div>
          <select class="input-border" v-model="item.billing_status" style="width:160px">
            <option v-for="(item,idx) in option.billingStatus" :key="`option-billing-status-${idx}`"
                    :value="item.value">{{ item.label }}</option>
          </select>
        </div>

        <div class="grid-item">
          <div class="grid-title">청구일</div>
          <admin-date-picker :data="item.billing_date"
                             @setDate="res => item.billing_date = res"></admin-date-picker>
        </div>

        <div class="grid-item" v-if="[0, 2].indexOf(item.pay_method) > -1 && !updateItem">
          <div class="grid-title">결제처리</div>
          <div class="unselect flex-align" style="gap:0 4px">
            <input type="checkbox" v-model="isAccount" id="account-check">
            <label for="account-check" class="size-14">등록과 함께 빌링 결제</label>
          </div>
        </div>
        <div class="grid-item" v-if="!add.visible">
          <div class="grid-title">결제 금액</div>
          <div class="flex-align" style="width:150px;gap:0 8px">
            <input type="number" class="input-border"
                   v-model="item.account_price"
                   @keyup="e => item.account_price = Number(e.target.value)">
            <div>원</div>
          </div>
        </div>
        <div class="grid-item">
          <div class="grid-title">상태</div>
          <div style="width:100px">
            <select class="input-border" v-model="item.status">
              <option :value="0">결제대기</option>
              <option v-if="[0, 2, 3].indexOf(item.pay_method) > -1" :value="1">결제완료</option>
              <option v-else :value="2">입금완료</option>
            </select>
          </div>
        </div>
        <div class="grid-item">
          <div class="grid-title">결제일</div>
          <admin-date-picker :data="item.account_date"
                             @setDate="res => item.account_date = res"></admin-date-picker>
        </div>
        <div class="grid-item">
          <div class="grid-title">세금계산서 발행일</div>
          <admin-date-picker :data="item.taxbill_date"
                             @setDate="res => item.taxbill_date = res"></admin-date-picker>
        </div>
      </div>
      <div class="button-group" style="padding-top:12px">
        <button class="button is-light" @click="clickCancel">취소</button>

        <button v-if="updateItem"
                class="button is-primary2" @click="clickDelete">삭제</button>

        <button v-if="item && item.pay_method === 1 && item.status === 2 && !updateItem.invoice_date"
                class="button is-primary" style="width:148px"
                @click="clickAccept(true)">저장/입금완료 메일 발송</button>
        <button class="button is-primary" v-else @click="clickAccept">저장</button>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
  import { SweetModal } from "sweet-modal-vue";
  import LpAdmDropInput from "../../../../module/common/LpAdmDropInput";
  import moment from 'moment';

  export default {
    name: 'ModalUtilize',
    components: {
      LpAdmDropInput,
      SweetModal
    },
    props: {
      service_id: {
        type: Number,
        default: 0
      },
      updateItem: {
        type: Object
      }
    },
    data() {
      return {
        add: {
          visible: false,
          product: {
            partner_id: 1,
            name: '',
            simple_desc: '',
          },
          price: {
            price: 0
          }
        },
        item: undefined,
        option: {
          payMethod: [
            {value: 0, label: '빌링결제(이니시스)'},
            {value: 1, label: '계좌이체'},
            {value: 2, label: '빌링결제(페이플)'},
            {value: 3, label: '충전금 소진'}
          ],
          billingStatus: [
            {value:0, label: '청구대기'},
            {value:1, label: '청구완료'},
          ],
          category: [],
          service: [],
          product: [],
        },
        selVal: {
          service: '',
          product: ''
        },
        isAccount: false
      }
    },
    watch: {
      isAccount(n) {
        if(n) {
          this.item.status = 1;
          this.item.account_date = moment().format('YYYY-MM-DD');
          this.item.account_price = this.item.product_price;
        }
      },
      'item.status'(n) {
        if(n>=1) {
          if(!this.item.account_date) {
            this.item.account_date = moment().format('YYYY-MM-DD');
            this.item.account_price = this.item.product_price;
          }
        }
      },
      async 'item.category_id'(n) {
        if(n) {
          let prod_res = await this.$axios.get(`public/product?cat2=${n}`);
          this.option.product = prod_res.data.data.map(i => {
            return {
              label: i.name,
              value: i.id,
              price: i.price.price
            }
          })
        }
      }
    },
    methods: {
      sendMailSuccess() {
        this.$axios.post(this.getUrl(`launchpack/service/utilize_send_mail_transfer/${this.item.id}`), this.item)
          .then(() => {
            this.toast('저장 및 발송되었습니다.');
            this.$refs.modal.close();
          });
      },
      onSelectService(res) {
        this.selVal.service = res.label;
        this.item.service_id = res.value;
      },
      onSelectProduct(res) {
        this.selVal.product = res.label;
        this.item.product_id = res.value;
        this.item.product_price = res.price;
      },
      async init() {
        this.add = {
          visible: false,
          product: {
            partner_id: 1,
            name: '',
            simple_desc: '',
          },
          price: {
            price: 0
          }
        };
        // 카테고리
        if(this.option.category.length === 0) {
          let res = await this.$axios.get('public/category?parent_id=50');
          this.option.category = res.data.map(i => {
            return {
              label: i.name,
              value: i.id
            }
          })
        }

        // 서비스
        if(this.option.service.length === 0) {
          let res = await this.$axios.get(this.getUrl('launchpack/service/simple'));
          this.option.service = res.data;
        }


        if(this.service_id > 0) {
          this.selVal.service = this.option.service.filter(i => i.value === this.service_id)[0].label;
        }

        let admin = this.$store.getters.admin;
        this.item = undefined;
        setTimeout(()=>{
          if(this.updateItem) {
            this.item = {
              id: this.updateItem.id,
              manager_id: admin.id,
              manager: {
                id: admin.id,
                name: admin.name
              },
              service_id: this.service_id,
              category_id: this.updateItem.category,
              product_id: this.updateItem.product,
              product_price: this.updateItem.product_price,
              account_price: this.updateItem.account_price,
              pay_method: this.updateItem.pay_method,
              billing_date: this.updateItem.billing_date.replace(' 00:00',''),
              account_date: this.updateItem.account_date ? this.updateItem.account_date.replace(' 00:00','') : null,
              taxbill_date: this.updateItem.taxbill_date ? this.updateItem.taxbill_date.replace(' 00:00','') : null,
              status: this.updateItem.status,
              billing_status: this.updateItem.billing_status
            };
            this.selVal.product = this.updateItem.product_name;
          } else {
            this.item = {
              manager_id: admin.id,
              manager: {
                id: admin.id,
                name: admin.name
              },
              service_id: this.service_id,
              category_id: 0,
              product_id: 0,
              product_price: 0,
              account_price: 0,
              pay_method: 2,
              billing_status: 0,
              billing_date: moment().format('YYYY-MM-DD'),
              account_date: null,
              taxbill_date: null,
              status: 0
            };
          }
        })
      },
      onClose() {
        this.selVal.service = '';
        this.selVal.product = '';
        this.$emit('close');
      },
      open() {
        this.init();
        this.$refs.modal.open();
      },
      clickCancel() {
        this.$refs.modal.close();
      },
      clickDelete() {
        this.$axios.delete(this.getUrl(`launchpack/service/utilize/${this.item.id}`), this.item).then(()=>{
          this.$refs.modal.close();
        });
      },
      async clickAccept(isSendMail=false) {
        if(this.add.visible) {
          this.add.product.category1_id = 50;
          this.add.product.category2_id = this.item.category_id;
          let res = await this.$axios.post(this.getUrl('product'), this.add);
          this.item.product_id = res.data.id;
          this.item.product_price = this.add.price.price;
        }
        if(this.updateItem) {
          this.$axios.patch(this.getUrl(`launchpack/service/utilize/${this.item.id}`), this.item)
            .then(() => {
              if(isSendMail) {
                this.sendMailSuccess();
              } else {
                this.toast('저장되었습니다.');
                this.$refs.modal.close();
              }
          });
        } else {
          this.$axios.post(this.getUrl(`launchpack/service/${this.item.service_id}/utilize`), this.item).then(() => {
            this.toast('등록되었습니다.');
            this.$refs.modal.close();
          });
        }
      }
    }
  }
</script>
<style lang="stylus" scoped>
  .modal-utilize-container
    color #363636

  .modal-title
    font-size 20px
    font-weight 700

  .grid-item
    display grid
    grid-template-columns 120px 1fr
    column-gap 12px
    align-items center
    padding-bottom 12px
  .grid-item:last-child
    margin-bottom 0
    border-bottom 0

  .grid-title
    font-size 14px

  .button-primary
    font-size 13px
    padding 4px 0
    margin 4px 0
    color #ff5722
    width 68px

  .box-add
    border 1px solid #dddddd
    padding 8px
    border-radius 4px
  .box-title
    font-size 13px
    margin 12px 0 4px
  .box-title:first-child
    margin-top 0

  .divider
    width 100%
    height 1px
    margin 8px 0
    background-color #dddddd

  .button-group
    margin-top 24px
    display flex
    align-items center
    justify-content flex-end
    gap 12px
</style>

<style lang="stylus">
  .sweet-modal-overlay
    -webkit-perspective initial

  .modal-utilize-container
    .sweet-modal.is-alert
      width 544px
    .sweet-modal.is-alert .sweet-content
      padding 28px 32px 16px 32px
</style>
